/**
 * Placeholder domain hubs (Finance / QHSE / Crewing) until those surfaces ship.
 * Breadcrumb: Home › Agent Hub › <Domain>.
 */

import { EmptyState } from '@syia-ai/maritimeai-ui';
import SimpleLayout from '@/components/SimpleLayout';
import { LinkButton } from '@/components/ui';

interface DomainPlaceholderProps {
  title: string;
  path: string;
  blurb: string;
}

export default function DomainPlaceholder({ title, path, blurb }: DomainPlaceholderProps) {
  return (
    <SimpleLayout
      currentPath={path}
      crumbs={[
        { label: 'Agent Hub', to: '/agent-hub' },
        { label: title },
      ]}
      subtitle={blurb}
      headerTitle={title}
    >
      <EmptyState
        className="shell-page-state"
        headingLevel={2}
        title={`${title} agents are coming soon`}
        description="Use Ship Management for the live prioritised overview."
        actions={<LinkButton to="/agent-hub/ship-management">Open Ship Management</LinkButton>}
      />
    </SimpleLayout>
  );
}

export function FinanceHub() {
  return (
    <DomainPlaceholder
      title="Finance"
      path="/agent-hub/finance"
      blurb="Track budgets, invoices, and financial performance across vessels and voyages."
    />
  );
}

export function QhseHub() {
  return (
    <DomainPlaceholder
      title="QHSE"
      path="/agent-hub/qhse"
      blurb="Monitor quality, health, safety, and environmental compliance across operations."
    />
  );
}

export function CrewingHub() {
  return (
    <DomainPlaceholder
      title="Crewing"
      path="/agent-hub/crewing"
      blurb="Manage crew assignments, certifications, and rotations across the fleet."
    />
  );
}
